import script from "./StatListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StatListItem.vue?vue&type=script&setup=true&lang=js"

import "./StatListItem.vue?vue&type=style&index=0&id=4553ab72&lang=css"

const __exports__ = script;

export default __exports__